import styled from "styled-components";

export const StyledProductPartsView = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  background-color: #fff;
`;
